import { useUndo } from "../../Utils/undo";
import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
import TickerContext from "../../context/ticker";
import ProjectContext from "../../context/ProjectContext";
import { Tooltip } from "react-tippy";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import AudioPop from "../bottom.component/timelineSetting/audioPop";
import { async } from "@firebase/util";
import AuthContext from "../../context/userAuth.context";

const SoundSettings = () => {
  const {
    LeftPanelActive,
    setLeftPanelActive,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    EditorZoom,
    setTTSData,
    editableObject,
    LayersData,
    setLayersData,
    setChangeCount,
    ChangeCount,
    seteditableObject,
    clone,
    isTTS,
    setIsTTS,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    Tl_TotalTime,
    calculateTimeByWidth,
    timelineZoomVal,
    calculateWidthByDuration,
    setitems,
    onePxEquivalent,
  } = useContext(MyContext);
  const undo = useUndo();

  const {
    setTickerPosition,
    TickerPosition,
    setTickerStart,
    ReverseLayer,
    setClick_TickerPosition,
    TickerRef,
    TickerState,
    setTickerState,
  } = useContext(TickerContext);
  const { slides, setslides } = useContext(ProjectContext);
  const { authenticationData } = useContext(AuthContext);
  var GoogleFonts = require("../../assets/GoogleFonts.json");

  const [values, setvalues] = useState(editableObject.editableItem);
  const [audioVolume, setaudioVolume] = useState(values.volume);
  const [fadeIn, setfadeIn] = useState(values.fadeIn);
  const [fadeOut, setfadeOut] = useState(values.fadeOut);
  useEffect(() => {
    setvalues(editableObject.editableItem);
  }, [editableObject]);
  var currsize;

  useEffect(() => {
    setaudioVolume(values.volume);
  }, [values]);

  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  //Lock function
  const lockFun = async () => {
    undo("lockFun"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].lock = !array[i].lock;
        array[i].Editable = false;
        break;
      }
    }
    setLayersData(array);
    //leftPanelHide
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Extending sound to all Slides function
  const extendtoAllSlide = async () => {
    undo("extendtoAllSlide"); // Ctrl+Z goes back to before this change
    //we have added a property extend to all slides in layers data so we can use it now
    // const array = Array.from(LayersData);
    // for (let i = 0; i < array.length; i++) {
    //   if (array[i].key === values.key) {
    //     if (array[i].extendtoAllSlides === false) {
    //       array[i].extendtoAllSlides = true;
    //     } else {
    //       array[i].extendtoAllSlides = false;
    //     }
    //     break;
    //   }
    // }
    // setLayersData(array);

    let _SoundWidth = values.widthOnTimeline;
    const _slide = Array.from(slides);
    const _Data = await create_Slide_And_Add_Sound(_SoundWidth, _slide);
    const activeIndexLayerData = _Data.find(
      (x) => x.IsActive == true
    ).LayerData;

    setLayersData(activeIndexLayerData);
    // setslides(_Data)
  };

  // useEffect(() => {

  //   slides.map(_value =>{

  //     if(_value.IsActive){
  //       if(_value.ExtendToAllSlide)
  //       {
  //         setLayersData(_value.LayerData)
  //       }
  //     }

  //   })

  // }, [slides])

  const create_Slide_And_Add_Sound = async (_SoundWidth, _slide) => {
    for (let i = 0; i < _slide.length; i++) {
      let slide_value = _slide[i];
      if (!slide_value.ExtendToAllSlide) {
        if (slide_value.scaleEnd <= _SoundWidth) {
          if (slide_value.LayerData.length > 0) {
            let index = null;

            for (let j = 0; j < slide_value.LayerData.length; j++) {
              let layer_value = slide_value.LayerData[j];
              let layer_index = j;
              if (layer_value.path === values.path) {
                _SoundWidth = _SoundWidth - slide_value.scaleEnd;
                layer_value.widthOnTimeline = slide_value.scaleEnd;
                index = layer_index;
                layer_value.duration = calculateTimeByWidth(
                  layer_value.widthOnTimeline
                );
              }
            }

            if (index === null) {
              _SoundWidth = _SoundWidth - slide_value.scaleEnd;
              const _PreviousValue = _slide.find(
                (x) => x.key === slide_value.key - 1
              );
              let start = 0;
              if (_PreviousValue) {
                start = _PreviousValue.startBackground;
              }
              const _newLayer = await add_Layer(
                slide_value.scaleEnd,
                slide_value.LayerData,
                start
              );
              slide_value.LayerData.push(_newLayer);
            }
          } else {
            _SoundWidth = _SoundWidth - slide_value.scaleEnd;
            const _PreviousValue = _slide.find(
              (x) => x.key === slide_value.key - 1
            );
            let start = 0;
            if (_PreviousValue) {
              start = _PreviousValue.startBackground;
            }
            const _newLayer = await add_Layer(
              slide_value.scaleEnd,
              slide_value.LayerData,
              start
            );
            slide_value.LayerData.push(_newLayer);
          }
        } else {
          if (slide_value.LayerData.length > 0) {
            let index = null;
            for (let j = 0; j < slide_value.LayerData.length; j++) {
              let layer_value = slide_value.LayerData[j];
              let layer_index = j;
              if (layer_value.path === values.path) {
                layer_value.widthOnTimeline = _SoundWidth;
                index = layer_index;
                _SoundWidth = _SoundWidth - slide_value._SoundWidth;
                layer_value.duration = calculateTimeByWidth(
                  layer_value.widthOnTimeline
                );
              }
            }
            if (index === null) {
              const _temp = _SoundWidth;
              _SoundWidth = _SoundWidth - slide_value.scaleEnd;
              const _PreviousValue = _slide.find(
                (x) => x.key === slide_value.key - 1
              );
              let start = 0;
              if (_PreviousValue) {
                start = _PreviousValue.startBackground;
              }
              const _newLayer = await add_Layer(
                _temp,
                slide_value.LayerData,
                start
              );
              slide_value.LayerData.push(_newLayer);
            }
          } else {
            const _temp = _SoundWidth;
            const _PreviousValue = _slide.find(
              (x) => x.key === slide_value.key - 1
            );
            let start = 0;
            if (_PreviousValue) {
              start = _PreviousValue.startBackground;
            }
            _SoundWidth = _SoundWidth - slide_value.scaleEnd;
            const _newLayer = await add_Layer(
              _temp,
              slide_value.LayerData,
              start
            );
            slide_value.LayerData.push(_newLayer);
          }
        }
      }
      slide_value.ExtendToAllSlide = true;
    }
    return _slide;
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const add_Layer = async (width, LayersData) => {
    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    var typelength = 1;
    var checkKey = 0;
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type === "audio") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }
    const _duration = calculateTimeByWidth(width);
    let currTime = calculateTimeByWidth(0);

    let newEntryLayerData = {
      key: checkKey + 1,
      AnimationId: makeid(8),
      layerIndex: topIndex,
      type: "audio",
      bgColor: "#ffb568",
      Name: "audio",
      path: values.path,
      audioTime: values.time,
      canvas: null,
      userFile: "xyz",
      index: null,
      TimelineZoom: timelineZoomVal,
      duration: _duration,
      startSound: width,
      startTime: currTime,
      endTime: "00:00:40:000",
      ExtendToAllSlide: true,
      volume: null,
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      audio_node: null,
      typeIcon: "audiotrack",
      Svglooping: false,
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      x: 0,
      y: 0,
      volume: 100,
      layerlock: false,
      opc: 1, //its use for the eye on the timeline wrapper for lock
      hidden: false,
      Editable: true,
      startPositionOnTimeline: 0,
      player: false,
      extendtoAllSlides: false,
      loop: false,
      fadeIn: 0,
      fadeOut: 0,
    };
    //1px is equal to 13.28ms and 15.06px is 200ms so 1s equals to 75.30px so now calculate width based on duration
    newEntryLayerData.widthOnTimeline = width;
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;

    // setChangeCount(ChangeCount + 1);

    return newEntryLayerData;
  };

  //Looping sound when it ends, Either for All slides or one slide.
  const loopAudio = () => {
    undo("loopAudio"); // Ctrl+Z goes back to before this change
    //we have added a property loop in layers data so we can use it now
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (array[i].loop === false) {
          array[i].loop = true;
        } else {
          array[i].loop = false;
        }
        break;
      }
    }
    setLayersData(array);
  };

  //Control Volume
  const controlVolume = (value) => {
    undo("controlVolume"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].volume = value;
        break;
      }
    }
    setLayersData(array);
    setaudioVolume(value);
  };

  //fade in sound in seconds
  const fadeInSound = (value) => {
    undo("fadeInSound"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].fadeIn = value;
        break;
      }
    }
    setLayersData(array);
    setfadeIn(value);
  };
  //fade out sound in seconds
  const fadeOutSound = (value) => {
    undo("fadeOutSound"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].fadeOut = value;
        break;
      }
    }
    setLayersData(array);
    setfadeOut(value);
  };
  // fit sound in slide time
  const FunCommit = () => {
    undo("FunCommit"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (
          array[i].widthOnTimeline + array[i].startPositionOnTimeline >
          Tl_TotalTime.width
        ) {
          array[i].widthOnTimeline =
            Tl_TotalTime.width - array[i].startPositionOnTimeline;
        } else {
          array[i].widthOnTimeline =
            Tl_TotalTime.width - array[i].startPositionOnTimeline;
        }

        array[i].duration = calculateTimeByWidth(array[i].widthOnTimeline);
      }
    }
    setLayersData(array);
  };

  function msTomini(ms) {
    let seconds = (ms / 1000).toFixed(1);
    let minutes = (ms / (1000 * 60)).toFixed(1);
    let hours = (ms / (1000 * 60 * 60)).toFixed(1);
    let days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
    if (seconds < 60) return seconds + " s";
    else if (minutes < 60) return minutes + " m";
    else if (hours < 24) return hours + " h";
    else return days + " d";
  }

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };
  // sound cut
  const Content_Cut = async () => {
    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
    var typelength = 1;
    var checkKey = 0;
    var topIndex = 0;
    var totalLength = 0;
    var widthOfLayer = 0;
    var _SoundStartFrom;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (LayersData[i].type === values.type) {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
      if (array[i].key === values.key) {
        if (array[i].startSound) {
          _SoundStartFrom = array[i].startSound;
        } else {
          _SoundStartFrom = 0;
        }

        totalLength = array[i].widthOnTimeline;
        array[i].widthOnTimeline =
          TickerPosition - array[i].startPositionOnTimeline;
        array[i].Editable = false;
        _SoundStartFrom = _SoundStartFrom + array[i].widthOnTimeline;
        widthOfLayer = array[i].widthOnTimeline;
        totalLength = Math.abs(totalLength - array[i].widthOnTimeline);

        array[i].duration = calculateTimeByWidth(array[i].widthOnTimeline);
        array[i].startTime = calculateTimeByWidth(
          array[i].startPositionOnTimeline
        );
        array[i].endTime = calculateTimeByWidth(
          array[i].startPositionOnTimeline + array[i].widthOnTimeline
        );
      }
    }

    const array2 = JSON.parse(JSON.stringify(values));
    array2.key = checkKey + 1;
    if (array2.type === "text") {
      array2.TextId = values.TextId + "-" + typelength;
    }
    array2.startPositionOnTimeline = TickerPosition;
    array2.LastStartPositionOnTimeline = TickerPosition;
    array2.widthOnTimeline = totalLength;
    array2.startSound = _SoundStartFrom;

    array2.startSoundInSeconds = calculateTimeByWidth(_SoundStartFrom);
    array2.type = "audio";
    array2.status = "Cut_video";

    array2.Name = `${values.type}-${typelength}`;
    array2.AnimationId = values.AnimationId + "-" + typelength;
    array2.layerIndex = topIndex;
    array2.toolbar = false;
    array2.FurtherSetting = false;
    array2.Editable = true;
    array2.Sound = new Audio(authenticationData.ApiBaseURL + "/" + array2.path);

    // (async () => {
    //   const url = authenticationData.ApiBaseURL + "/" + array2.path;
    //   const context = new AudioContext();
    //   const audioBuffer = await fetch(url, {
    //     mode: 'no-cors',
    //     method: 'GET',
    //     redirect: 'follow'
    //   })
    //     .then(res => res.arrayBuffer())
    //     .then(buffer => context.decodeAudioData(buffer));

    //   const play = (startTime, duration) => {
    //     const source = context.createBufferSource();
    //     source.buffer = audioBuffer;
    //     source.connect(context.destination);
    //     source.start(context.currentTime, startTime, duration);
    //   };

    //   [1, 3, 5, 10, 15, 18].forEach((startTime) => {
    //     const btn = document.createElement("button");
    //     btn.onclick = (evt) => play(startTime, 1);
    //     btn.textContent = "start at " + startTime + "s";
    //     document.body.append(btn);
    //   });
    // })().catch(console.error)

    array2.Sound.preload = "auto";
    //array2.Sound = source;

    array2.duration = calculateTimeByWidth(array2.widthOnTimeline);
    array2.startTime = calculateTimeByWidth(array2.startPositionOnTimeline);
    array2.endTime = calculateTimeByWidth(
      array2.startPositionOnTimeline + array2.widthOnTimeline
    );

    //debugger
    //msTomini(
    //totalTimeToMs(_smallTime)
    //);
    // var diff = calculateTimeByWidth(
    //   array2.startPositionOnTimeline + array2.widthOnTimeline
    // )

    // var tlength = totalTimeToMs(calculateTimeByWidth(slides.filter(x => x.IsActive == true)[0].TotalSlideWidth));
    // var dif = totalTimeToMs(diff);

    // if (dif > tlength) {
    //   var diff2 = dif - tlength;
    //   array2.endSound = convertSecondtoTimeString((dif - diff2) / 1000);
    // }
    // else {
    //   array2.endSound = diff;
    // }

    array2.Sound.currentTime = (_SoundStartFrom * onePxEquivalent) / 1000;
    //array2.Sound.addEventListener('canplaythrough', isAppLoaded, false);

    setLayersData(LayersData.concat(array2));

    seteditableObject({ showPanel: true, editableItem: array2 });
  };

  function convertSecondtoTimeString(seconds) {
    var sec_num = parseFloat(seconds);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;
    if (seconds.toString().includes(".")) {
      var mill = seconds.toString().split(".")[1] * 100;
      seconds = seconds.toString().split(".")[0];
    } else {
      var mill = "000";
    }
    //var milsec = (sec_num % 1)*1000;
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return `${hours}:${minutes}:${seconds}:${mill}`;
    // return [hours,minutes,seconds,milsec]
    //     .map(v => v < 10 ? "0" + v : v)
    //     .filter((v,i) => v !== "00" || i > 0)
    //     .join(":")
  }

  function loadSound(url, dogBarkingBuffer, context) {
    var request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.responseType = "arraybuffer";

    // Decode asynchronously
    request.onload = function () {
      context.decodeAudioData(request.response, function (buffer) {
        dogBarkingBuffer = buffer;
      });
    };
    request.send();
  }
  const deleteSound = (event) => {
    undo("deleteSound"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (var i in array) {
      if (array[i].Editable == true && array[i].type == "audio") {
        array.splice(i, 1);
        break;
      }
    }

    setLayersData(array);
  };

  const duplicateSound = (event) => {
    undo("duplicateSound"); // Ctrl+Z goes back to before this change
    var checkKey = 0;
    var topIndex = 0;
    var typelength = 1;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    const array = Array.from(LayersData);
    for (var i in array) {
      if (array[i].Editable == true && array[i].type == "audio") {
        if (LayersData[i].type === values.type) {
          typelength = typelength + 1;
        }
        if (LayersData[i].key >= checkKey) {
          checkKey = LayersData[i].key;
        }

        var obj = JSON.parse(JSON.stringify(values));
        obj.key = checkKey + 1;
        obj.Name = obj.Name + "-copy";
        obj.AnimationId = obj.AnimationId + "-" + checkKey;
        obj.layerIndex = topIndex;
        obj.Added = true;
        var finalJson = JSON.parse(JSON.stringify(obj));
        setLayersData(LayersData.concat(finalJson));
        //array.push(array[i]);
        break;
      }
    }

    //setLayersData(array);
  };

  const lockSound = () => {
    undo("lockSound"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].Editable == true && array[i].type == "audio") {
        array[i].layerlock = true;
        array[i].lock = true;
        array[i].Editable = true;
        break;
      }
    }

    setLayersData(array);
  };

  return (
    <div
    //   onClick={() => {
    //     if (showColorPicker) setshowColorPicker(false);
    //   }}
    >
      <div className="d-flex topOptions">
        <div className="settingsTitle bolderFont">Edit Sound</div>
        <div className="topRightOptions">
          <button
            className="btn btn-small btn-grey mr-2"
            onClick={duplicateSound}
          >
            Duplicate
          </button>
          <button
            className="btn btn-small btn-danger mr-2"
            onClick={(event) => deleteSound(event)}
          >
            Delete
          </button>
          <button className="btn btn-small btn-black" onClick={lockSound}>
            Lock
          </button>
        </div>
      </div>
      <div className="LabelWithSlider SoundPanel">
        <AudioPop popShow={false} value={values}></AudioPop>
      </div>
      <div className="LabelWithSlider Volume">
        <div className="settingsTitle">Volume Control</div>
        <div className="opacitySlider">
          <div className="rangeSlider">
            <InputRange
              maxValue={100}
              minValue={0}
              step={1}
              value={audioVolume}
              onChange={(value) => controlVolume(value)}
            />
          </div>
          <div className="opacityValue">{audioVolume}</div>
        </div>
      </div>
      <div className="LabelWithSlider Tools">
        <div className="settingsTitle mb-2">Tools</div>
        <div className="opacitySlider">
          <Tooltip
            title="Reduce to slide length"
            position="bottom"
            trigger="mouseenter"
            theme="transparent"
            arrow={true}
            animation="scale"
            size="small"
            delay={500}
          >
            <div
              className={
                values.loop === true
                  ? "toggleIconSettings disabled"
                  : "toggleIconSettings"
              }
              onClick={(e) => FunCommit()}
            >
              <span className="material-icons smallIcon selectIcon">
                commit
              </span>
            </div>
          </Tooltip>
          <Tooltip
            title="Split into two layers at play head"
            position="bottom"
            trigger="mouseenter"
            theme="transparent"
            arrow={true}
            animation="scale"
            size="small"
            delay={500}
          >
            <div
              disabled
              onClick={(e) => Content_Cut()}
              className={
                values.fontWeight === "bold"
                  ? "toggleIconSettingsActive"
                  : "toggleIconSettings"
              }
            >
              <span className="material-icons smallIcon selectIcon ">
                content_cut
              </span>
            </div>
          </Tooltip>
        </div>
      </div>
      {/* Loop (repeats the clip until the slide ends) and ducking; the old Options block below
          stays hidden ("extend to all slides" is not supported in the export). */}
      {(() => {
        const live = LayersData.find((l) => l.key === values.key) || values;
        const toggle = (field, on) => {
          undo(field);
          setLayersData(LayersData.map((l) => (l.key === values.key ? { ...l, [field]: on } : l)));
        };
        return (
          <div className="LabelWithSlider Options">
            <div className="settingsTitle mb-2">Options</div>
            <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer", marginBottom: 4 }}>
              <input type="checkbox" checked={!!live.loop} onChange={(e) => toggle("loop", e.target.checked)} />
              Loop until the end of the slide
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer" }}>
              <input type="checkbox" checked={!!live.duckUnderVoices} onChange={(e) => toggle("duckUnderVoices", e.target.checked)} />
              Lower while characters speak
            </label>
          </div>
        );
      })()}
      {/* <div className="LabelWithSlider Options">
        <div className="settingsTitle mb-2">Options</div>
        <div className="opacitySlider">
          <Tooltip
            title="Extend to all slides"
            position="bottom"
            trigger="mouseenter"
            theme="transparent"
            arrow={true}
            animation="scale"
            size="small"
            delay={500}
          >
            <div
              onClick={extendtoAllSlide}
              className={
                values.extendtoAllSlides === true
                  ? "toggleIconSettingsActive"
                  : "toggleIconSettings"
              }
            >
              <span className="material-icons smallIcon selectIcon">
                web_stories
              </span>
            </div>
          </Tooltip>
          <Tooltip
            title="Loop"
            position="bottom"
            trigger="mouseenter"
            theme="transparent"
            arrow={true}
            animation="scale"
            size="small"
            delay={500}
          >
            <div
              onClick={loopAudio}
              className={
                values.loop === true
                  ? "toggleIconSettingsActive"
                  : "toggleIconSettings"
              }
            >
              <span className="material-icons smallIcon selectIcon">
                all_inclusive
              </span>
            </div>
          </Tooltip>
        </div>
      </div> */}
      <div className="LabelWithSlider SoundTransition mt-3 mb-3">
        <div className="settingsTitle mb-2">Sound Transition</div>
        <div className="inputGroup">
          <label style={{ fontSize: "10px" }}>Fade In (sec): </label>
          <input
            className="XYpostion"
            type="number"
            min="0"
            max="5"
            step="0.5"
            value={fadeIn}
            onChange={(event) => fadeInSound(event.target.value)}
          />
        </div>
        <div className="inputGroup">
          <label style={{ fontSize: "10px" }}>Fade Out (sec): </label>
          <input
            className="XYpostion"
            type="number"
            min="0"
            max="5"
            step="0.5"
            value={fadeOut}
            onChange={(event) => fadeOutSound(event.target.value)}
          />
        </div>
      </div>
    </div>
  );
};
export default SoundSettings;
